import styled from 'styled-components'

export const Container = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: min-content;
    border-top: 1px solid ${({ theme }) => theme.colors.graphics};
`
